import { render, staticRenderFns } from "./UnitProductPageCleaner.vue?vue&type=template&id=20db753d&scoped=true"
import script from "./UnitProductPageCleaner.vue?vue&type=script&lang=js"
export * from "./UnitProductPageCleaner.vue?vue&type=script&lang=js"
import style0 from "./UnitProductPageCleaner.vue?vue&type=style&index=0&id=20db753d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20db753d",
  null
  
)

export default component.exports